"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScriptsSrc = void 0;
/**
 * Obtiene el array de scripts a cargar segun versión y entorno
 * @param {currentEnv} string  dev||qa||prod, viene de process.env.NEXT_PUBLIC_ENV_NAME
 * @param {versions} object bjeto con las versines de cada script
 * @returns {array} array con src de cada script
 */
const getScriptsSrc = ({ currentEnv, versions }) => {
    const paths = {
        IC: `https://${currentEnv}.cms.col.movistar.es/static/js/ic/`,
        context: `https://${currentEnv}.cms.col.movistar.es/static/js/context/`,
        nookinfoexchange: `https://${currentEnv}.cms.col.movistar.es/static/js/nookinfoexchange/`,
        metrics: `https://${currentEnv}.cms.col.movistar.es/static/js/metrics/`,
    };
    if (versions) {
        if (versions.IC) {
            paths.IC = `${paths.IC}${versions.IC}/IC.js`;
        }
        else {
            paths.IC = `${paths.IC}IC.js`;
        }
        if (versions.context) {
            if (versions.context === '0') {
                paths.context = '';
            }
            else {
                paths.context = `${paths.context}${versions.context}/context.js`;
            }
        }
        else {
            paths.context = `${paths.context}context.js`;
        }
        if (versions.nookinfoexchange) {
            if (versions.nookinfoexchange === '0') {
                paths.nookinfoexchange = '';
            }
            else {
                paths.nookinfoexchange = `${paths.nookinfoexchange}${versions.nookinfoexchange}/nook-info-exchange.js`;
            }
        }
        else {
            paths.nookinfoexchange = `${paths.nookinfoexchange}nook-info-exchange.js`;
        }
        if (versions.metrics) {
            if (versions.metrics === '0') {
                paths.metrics = '';
            }
            else {
                paths.metrics = `${paths.metrics}${versions.metrics}/metrics.js`;
            }
        }
        else {
            paths.metrics = `${paths.metrics}metrics.js`;
        }
    }
    const result = Object.values(paths);
    return result;
};
exports.getScriptsSrc = getScriptsSrc;
//# sourceMappingURL=utils.js.map